export const BASE_CLASS_NAME = 'table';

export const getClassName = (name: string) => `${BASE_CLASS_NAME}__${name}`;
